import { useEffect, useRef } from 'react';

// Keyboard triage for the review panel: ↑/↓ move between open findings,
// ←/→ between categories, A apply, D dismiss, E edit, R refine, C copy.
// Keys typed into a field or a dialog, or with Cmd/Ctrl/Alt held, are left
// alone; TinyMCE's iframe keeps the editor's own keys to itself.
const ACTIONS = {
    ArrowDown: 'next',
    ArrowUp: 'prev',
    ArrowRight: 'nextTab',
    ArrowLeft: 'prevTab',
    a: 'apply',
    d: 'dismiss',
    e: 'edit',
    r: 'refine',
    c: 'copy',
};

const isTyping = target => {
    const tag = (target?.tagName || '').toLowerCase();
    return tag === 'input' || tag === 'textarea' || tag === 'select' || !!target?.isContentEditable;
};

// Calls onAction(action) for each triage key while enabled; when it returns
// true the key's default (scrolling, say) is suppressed.
export default function useTriageKeys(enabled, onAction) {
    const latest = useRef(onAction);
    latest.current = onAction;

    useEffect(() => {
        if (!enabled) return undefined;
        const onKey = (e) => {
            if (e.metaKey || e.ctrlKey || e.altKey) return;
            if (isTyping(e.target) || e.target?.closest?.('.p-dialog')) return;
            const action = ACTIONS[e.key.length === 1 ? e.key.toLowerCase() : e.key];
            if (action && latest.current(action)) e.preventDefault();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [enabled]);
}
